import { createContext, useContext, useState, useEffect, PropsWithChildren } from "react";

const PWAContext = createContext<{
  deferredPrompt: BeforeInstallPromptEvent | null,
  clearDeferredPrompt: () => void,
  isUsingApp: boolean,
  isIOS: boolean,
} | undefined>(undefined);

export const usePWAContext = () => {
  const context = useContext(PWAContext);
  if (!context) throw new Error("usePWAContext must be used in PWAContextProvider");
  return context;
};

export const PWAContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  const [isUsingApp, setIsUsingApp] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
    setIsIOS(isIosDevice);

    if (window.matchMedia("(display-mode: standalone)").matches) {
      setIsUsingApp(true);
    }

    const handleBeforeInstallPrompt = (e: BeforeInstallPromptEvent) => {
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt as any);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt as any);
    };
  }, []);

  return (
    <PWAContext.Provider value={{ 
        deferredPrompt, 
        clearDeferredPrompt: () => setDeferredPrompt(null), 
        isUsingApp, 
        isIOS 
      }}>
      {children}
    </PWAContext.Provider>
  );
};
